import React from 'react';

/** Plain settings building blocks: a semibold title over a hairline, then rows. */

export const rowLabel = 'w-40 shrink-0 text-[13px] text-[color:var(--text-muted)]';
export const rowValue = 'min-w-0 flex-1 text-[13px] text-[color:var(--text-primary)]';
export const textBtn =
  'rounded text-[12px] font-medium text-[color:var(--text-secondary)] transition-colors hover:text-[color:var(--text-primary)] disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--state-focus-ring)]';
export const neutralBtn =
  'inline-flex h-7 items-center justify-center gap-1.5 rounded-md border border-[color:var(--border-default)] px-3 text-[12px] font-medium text-[color:var(--text-primary)] transition-colors hover:bg-[color:var(--surface-hover)] disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--state-focus-ring)]';
export const primaryBtn =
  'inline-flex h-7 items-center justify-center gap-1.5 rounded-md bg-brand px-3 text-[12px] font-medium text-[color:var(--text-on-brand)] transition-colors hover:bg-brand-hover disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--state-focus-ring)]';
export const inputCls =
  'h-8 w-full rounded-md border border-[color:var(--border-default)] bg-transparent px-2 text-[13px] text-[color:var(--text-primary)] placeholder:text-[color:var(--text-disabled)] focus:border-[color:var(--border-strong)] focus:outline-none';

export function Section({ title, children, className = '' }) {
  return (
    <section className={`mb-8 ${className}`}>
      <h2 className="border-b border-[color:var(--border-default)] pb-2 text-[13px] font-semibold text-[color:var(--text-primary)]">
        {title}
      </h2>
      <div>{children}</div>
    </section>
  );
}

export function Row({ label, children, align = 'center' }) {
  return (
    <div
      className={`flex flex-col gap-1 border-b border-[color:var(--border-subtle)] py-2.5 sm:flex-row sm:gap-4 ${
        align === 'start' ? 'sm:items-start' : 'sm:items-center'
      }`}
    >
      <div className={rowLabel}>{label}</div>
      <div className="flex min-w-0 flex-1 items-center gap-3">{children}</div>
    </div>
  );
}

export function Switch({ checked, onChange, disabled, label }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative h-4 w-7 shrink-0 rounded-full border transition-colors disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--state-focus-ring)] ${
        checked
          ? 'border-transparent bg-brand'
          : 'border-[color:var(--border-strong)] bg-transparent'
      }`}
    >
      <span
        className={`absolute top-1/2 h-2.5 w-2.5 -translate-y-1/2 rounded-full transition-all ${
          checked
            ? 'left-[14px] bg-[color:var(--text-on-brand)]'
            : 'left-[2px] bg-[color:var(--text-muted)]'
        }`}
      />
    </button>
  );
}
